(function () {
    angular.module('journey-loader.dir', ['journey.canvas.srv'])
        .directive('journeyLoader', ['$rootScope', 'canvasService', '$timeout', '$interval', '$compile', 'plumbService', 'signalSrv', 'helpers', journeyLoader]);

    function journeyLoader($rootScope, canvasService, $timeout, $interval, $compile, plumbService, signalSrv, helpers) {
        return {
            controller: ['$rootScope', '$scope', function ($rootScope, $scope) {

                var setLoaderData = function (type, journeyId) {
                    switch (type) {
                        case 'active':
                        case 'service':
                            return JSON.parse($scope.journeyRes);
                            break;
                        case 'local':
                            if (canvasService.journeyStorageExists(journeyId)) {
                                return canvasService.getJourneyStorage(journeyId);
                            }
                            break;
                    }
                };

                $scope.hasTriggered = false;
                $timeout(() => {
                    $scope.$emit('allPromisesResolved');
                }, 0);

                $scope.$on('allPromisesResolved', function(){
                    if(!$scope.hasTriggered){
                        $scope.hasTriggered = true;
                        $scope.allElementsCreated = false;
                        $scope.allElementsConnected = false;

                        $rootScope.loaderData = setLoaderData($scope.loaderType, $scope.journeyStorageId) || [];
                        $rootScope.unique = '';
                        if($scope.loaderType === 'active') {
                            $scope.$emit('triggerActiveLoader');
                        }else {
                            if($rootScope.loaderData.length <= 0) {
                                $scope.$emit('displayJourney', true);
                            }
                            else if ($rootScope.loaderData[0].type !== 'Entry') {
                                $scope.$emit('displayJourney', true);
                            }

                            $scope.$emit('triggerLoaderData');
                        }
                    }
                });

            }],
            link: function ($scope) {

                var createDomElements = function(elem, lastElem = false) {
                    var directiveName,
                        newScope = $scope.$new(true);

                    if(elem) {
                        directiveName = getObjVal(elem.elemClass);
                    }

                    if(elem.type !== 'RectangleConnection' && elem) {
                        // load the journey
                        $timeout(function(){
                            $rootScope.cElement = elem;
                            $compile('<'+directiveName+'></'+directiveName+'>')(newScope);
                            if(lastElem) {
                                $timeout(() => {
                                    $scope.allElementsCreated = true;
                                }, 10);
                            }
                        }, 10);
                    }
                    else if(lastElem) {
                        $timeout(() => {
                            $scope.allElementsCreated = true;
                        }, 10);
                    }
                };

                var connectAllLoaderElements = function(elems, lastElem = false) {
                    var _hasChildren = function (el) {
                        var res = false;
                        if (el.hasOwnProperty('children')) {
                            if (el.children.length > 0) {
                                res = true;
                            }
                        }
                        return res;
                    };

                    while(elems.length > 0) {
                        var baseElem = elems[0];
                        if(baseElem.elemName !== 'IfElse' && baseElem.elemName !== 'EmailEngagement'){
                            if(_hasChildren(baseElem)){
                                for(var j = 0; j<baseElem.children.length; j++) {
                                    for(var i = 0; i<elems.length; i++) {
                                        if(baseElem.type === 'Looping') {
                                            const target = helpers.getConnectionById(baseElem.children[0]);
                                            plumbService.connectLoopingElements(baseElem, target);
                                        } else if(baseElem.children[j] === elems[i].id){
                                            plumbService.connectElements(baseElem, elems[i]);
                                        }
                                    }
                                }
                            }else {
                                // make element draggable
                                plumbService.makeDraggable(baseElem.id);
                                plumbService.setManualConnection(baseElem.color, baseElem.color);
                            }
                        }
                        elems.splice(0, 1);
                    }

                    if(lastElem) {
                        $timeout(() => {
                            $scope.allElementsConnected = true;
                        }, 0);
                    }
                };

                $scope.$on('triggerLoaderData', function(){
                    //Checks if we have data in localstorage
                    if ($rootScope.loaderData.length > 0 && typeof $rootScope.loaderData !== 'string') {
                        //Elements iterator
                        let totalNodes = $rootScope.loaderData.length;
                        for (var i = 0; i < totalNodes; i++) {
                            let cElem = $rootScope.loaderData[i];
                            let lastElem = (totalNodes - 1) === i;
                            createDomElements(cElem, lastElem);
                        }
                    } else {
                        // remove the loader once the promises resolve
                        $scope.$emit('jbLoader', false);
                    }
                });

                //afterDomElements were created
                $scope.$watch('allElementsCreated', (wereCreated) => {
                    if(wereCreated) {
                        $scope.$emit('jbLoader', false);
                        connectAllLoaderElements($rootScope.loaderData, true);
                    }
                });

                //all elements were connected lets move on
                $scope.$watch('allElementsConnected', (wereConnected) => {
                    if(wereConnected) {
                        // Todo: 'timer' remove this is just to test loading time
                        if(console && typeof console.timeEnd === 'function') {
                            console.timeEnd("answer time");
                        }
                        $scope.validateJourney();
                    }
                });

                var getObjVal = function(obj) {
                    var temp = Object.keys(obj);
                    return obj[temp[0]] || '';
                };

                var createActiveElement = function(aElem) {
                    var directiveName,
                        newScope = $scope.$new(true);

                    if(aElem.type === 'RectangleConnection') {
                        directiveName = 'active-' + aElem.elemClass;
                    } else {
                        directiveName = 'active-' + getObjVal(aElem.elemClass);
                    }

                    // load the journey
                    $timeout(function(){
                        $rootScope.aElement = aElem;
                        $compile('<'+directiveName+'></'+directiveName+'>')(newScope);
                    }, 0);
                };

                var connectAllElements = function(elems) {
                    var _hasChildren = function (el) {
                            var res = false;
                            if (el.hasOwnProperty('children')) {
                                if (el.children.length > 0) {
                                    res = true;
                                }
                            }
                            return res;
                        },
                        conns = elems.length || 0,
                        cont = 0;

                    while(conns > 0) {
                        var baseElem = elems[cont];

                        if(_hasChildren(baseElem)){
                            for(var j = 0; j<baseElem.children.length; j++) {
                                for(var i = 0; i<elems.length; i++) {
                                    if(baseElem.type === 'Looping') {
                                        const naturalId = helpers.getNaturalId(baseElem.children[0]);
                                        const target = helpers.getConnectionById(naturalId);
                                        plumbService.connectLoopingElements(baseElem, target);
                                    } else if(baseElem.children[j] === elems[i].id){
                                        plumbService.connectElements(baseElem, elems[i]);
                                    }
                                }
                            }
                        }

                        conns --;
                        cont ++;
                    }
                };

                $scope.$on('triggerActiveLoader', function(){
                    //Checks if we have data in local storage
                    if ($rootScope.loaderData.length > 0) {
                        var date = new Date(),
                            unique = date.getTime();

                        $rootScope.loaderData = $rootScope.loaderData.map(function (conn) {
                            conn.id = conn.id + '_' + unique;
                            conn.unique = unique;

                            if (conn.children) {
                                conn.children = conn.children.map(function (i) {
                                    return i + '_' + unique;
                                })
                            }

                            if (conn.parent) {
                                conn.parent = conn.parent + '_' + unique;
                            }

                            return conn;
                        });

                        $rootScope.unique = unique;

                        var data = $rootScope.loaderData;
                        //Elements iterator
                        for (var i = 0; i < data.length; i++) {
                            var aElem = data[i];
                            createActiveElement(aElem);
                        }
                        $timeout(function() {
                            $scope.$emit('jbLoader', false);
                            connectAllElements(data);
                        }, 1000);

                        // moving hub login to until the canvas comes back
                        var HUB = signalSrv.init(),
                            connection = $.hubConnection(HUB.URL),
                            downloader = connection.createHubProxy(HUB.NAME);

                        downloader.logging = true;

                        downloader.on("raiseMetric", function(msg) {
                            if(msg) {
                                var reportEl = JSON.parse(msg);
                                // emit the event
                                if(!reportEl.Error) {
                                    $timeout(function() {
                                        $rootScope.$emit('reporter_' + reportEl.JourneyId + reportEl.ElmentId + '_' + unique, reportEl.Count);
                                    }, 0);
                                }
                            }
                        });

                        connection.start().done(function() {
                            downloader.invoke(HUB.EVENT, $scope.jbId, '1', $rootScope.jbToken);
                        });
                    }else {
                        // remove the loader once the promises resolve
                        $scope.$emit('jbLoader', false);
                    }

                });

                $scope.validateJourney = () => {
                    let validRes = helpers.isValidJourney();

                    if (!validRes.isValid) {
                        if (validRes.unsavedData.length > 0) {
                            for (var i = 0; i < validRes.unsavedData.length; i++) {
                                $scope.$emit('emptyErr_' + validRes.unsavedData[i], true);
                            }
                        }

                        if (validRes.dummyNodes.length > 0) {
                            for (var i = 0; i < validRes.dummyNodes.length; i++) {
                                $scope.$emit('emptyErr_' + validRes.dummyNodes[i], true);
                            }
                        }
                    }

                    if(validRes.hasFacebookAudience.length) {
                        canvasService.getConnections()
                            .then(({data}) => {
                                if(!data.ValidConnection) {
                                    for(var i = 0; i<validRes.hasFacebookAudience.length; i++) {
                                        $scope.$emit('activateFbErr_' + validRes.hasFacebookAudience[i], true);
                                    }
                                }
                            });
                    }
                };
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/journey-loader.js